<template>
    <div class="conflicts-messages">
        <div class="conflict-associated" v-if="messages.associated" >
            <font-awesome-icon icon="link"></font-awesome-icon>
            <div v-html="messages.associated"></div>
        </div>
        <div class="conflict-created" v-if="messages.created">
            <font-awesome-icon icon="plus"></font-awesome-icon>
            <div v-html="messages.created"></div>
        </div>
        <div class="conflict-conflict" v-if="messages.conflict">
            <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
            <div v-html="messages.conflict"></div>
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {},
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {},
        mounted: function () {

        },
        name: '',
        props: {
            messages: {
                type: Object,
                default(){
                    return {}
                }
            }
        },
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
    .conflicts-messages{
        display: flex;
        padding: 0 10px;
        justify-content: space-between;
        margin: 10px 0 20px;

        &>div{
            flex: 0 0 30%;
            padding: 10px;
            box-shadow: 0 0 5px rgba(0,0,0,0.16);
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 0.8rem;
            position: relative;
            overflow: hidden;

            &.conflict-associated{
                color: $main-white;
                background-color: #17a2b8!important;
            }

            &.conflict-created{
                color: $main-white;
                background-color: #28a745!important;
            }

            &.conflict-conflict{
                color: $main-black;
                background-color: #ffc107!important;
            }

            .svg-inline--fa{
                position: absolute;
                top: 0;
                left: 0;
                font-size: 3rem;
                color: $main-black;
                opacity: 0.06;
                transform: rotate(15deg) translate(-5px,-5px);
            }

            strong{
                display: block;
                font-size: 1.5rem;
                margin-bottom: 5px;
                font-weight: $bold;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/plugins/formbuilder/ConflictsMessages.vue